import { useEffect, useState } from 'react'
import NavTitle from '../../../components/nav-title'
import TextNavTitle from '../../../components/TextNavTitle'
import CardCustom from '../../../components/custom/card-custom'
import { Button, Col, Form, Image, Row, Table } from 'react-bootstrap'
import {
  BsArrowClockwise,
  BsFillFileEarmarkPdfFill,
  BsSliders2Vertical
} from 'react-icons/bs'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import NavRoleOrg from '../../../components/nav-role-org'
import { useSelector } from 'react-redux'
import { Controller, useForm } from 'react-hook-form'
import InputSearchCustom from '../../../components/custom/InputSearchCustom'
import styled from 'styled-components'
import TableSkeletonBody from '../../../components/custom/TableSkeletonBody'
import ModalFilter from './ModalFilter'
import ExportExcel from './ExportExcel'
import { fnDateEn } from '../../../helper/fnDateEn'
// import { getEmpsAPI } from '../../../services/employee'
import excelImg from '../../../images/xlsFile.svg'
import { getReportEducationAPI } from '../../../services/employee'
import { fnGetEducationFile } from '../../../helper/fnGetEducationFile'

export default function ReportEducationPage() {
  const roleId = useSelector((state) => state.roleReducer.role)
  const [isLoading, setIsLoading] = useState(false)
  const [totalRow, setTotalRow] = useState(0)
  const [totalPerson, setTotalPerson] = useState(0)
  const [dataTable, setDataTable] = useState([])
  const totalLimits = 20
  const [bodyFilter, setBodyFilter] = useState()
  const [page, setPage] = useState(1)
  const [showFilter, setShowFilter] = useState(false)
  const to_day = new Date()

  useEffect(() => {
    const body = {
      page: 1,
      orgId: roleId
    }
    setPage(1)
    if (roleId) fnGetData(body)
  }, [roleId])

  const fnGetData = async (body, isExcel = false) => {
    setIsLoading(true)
    if (!isExcel) {
      setBodyFilter(body)
      setPage(body.page)
    }

    const datas = {
      ...body,
      code: body.code?.value ?? '',
      username: body.username?.value ?? '',
      name: body.name?.value ?? '',
      statusId: body.statusId?.value ?? '',
      typeId:
        body.typeId?.length > 0 ? body.typeId.map((item) => item.value) : [],
      positionId: body.position?.value ?? '',
      position: body.position?.label ?? '',
      nickname: body.nickname,
      reportTo: body.reportTo?.value ?? '',
      team: body.team?.label ?? '',
      teamId: body.team?.value ?? '',
      ...(body.levelId && {
        levelId:
          body.levelId?.length > 0 ? body.levelId.map((item) => item.value) : []
      }),
      educationDegree: body.educationDegree?.label ?? '',
      institutionName: body.institutionName ?? '',
      educationQualification: body.educationQualification ?? ''
    }

    const resp = await getReportEducationAPI(datas)

    setIsLoading(false)
    if (!resp) return
    if (resp.status) {
      setTotalPerson(resp.result.total_person)
      if (isExcel) {
        const dataExcel = resp.result.result.map((d, i) => {
          return {
            num: i + 1,
            // img: '',
            code: d.code,
            level: d.level_id,
            userName: d.username,
            title_th: d?.title_th,
            name_th: d?.name_th,
            surname_th: d?.surname_th,
            nickname_th: d.nickname_th,

            title_en: d?.title_en,
            name_en: d?.name_en,
            surname_en: d?.surname_en,
            nickname_en: d.nickname_en,

            division: d.division,
            division_th: d.division_th,
            division_en: d.division_en,

            department: d.department,
            department_th: d.department_th,
            department_en: d.department_en,

            faction: d.faction,
            faction_th: d.faction_th,
            faction_en: d.faction_en,

            team_th: d.team_th,
            team_en: d.team_en,

            position_th: d.position_th,
            position_en: d.position_en,

            report_to: d.report_to,

            start_date_th: d.start_date_th,
            start_date_en: d.start_date_en,

            contract_start_date_th: d.contract_start_date_th,
            contract_start_date_en: d.contract_start_date_en,

            duration_text: d.duration_text,

            employed_date_th: d.employed_date_th,
            employed_date_en: d.employed_date_en,

            contract_end_date_th: d.contract_end_date_th,
            contract_end_date_en: d.contract_end_date_en,

            end_date_th: d.end_date_th,
            end_date_en: d.end_date_en,

            resign: d.resign,
            type: d.type,

            education_degree: d.education_degree,
            institution_name: d.institution_name,
            admission_year: d.admission_year,
            graduation_year: d.graduation_year,
            education_qualification: d.education_qualification,
            faculty: d.faculty,
            major: d.major,
            grade: d.grade,
            transcript: d.tran_file_name ? 'มี' : 'ไม่มี',
            cer_file_name: d.cer_file_name ? 'มี' : 'ไม่มี'
          }
        })

        await ExportExcel({
          filterEx: resp.result.filters,
          data: dataExcel
        })
      } else {
        setDataTable(resp.result.result)
        setTotalRow(resp.totalRows)
      }
      setShowFilter(false)
    } else {
      setTotalRow(0)
      setDataTable([])
    }
  }

  const fnExportExcel = () => {
    const body = {
      ...bodyFilter,
      page: 1,
      size: totalRow
    }
    fnGetData(body, true)
  }

  const { control, setValue, handleSubmit } = useForm({})
  const onClearSearch = () => {
    const body = {
      ...bodyFilter,
      page: 1,
      orgId: roleId,
      searchs: ''
    }
    setPage(1)
    fnGetData(body)
  }
  const onSearch = (d) => {
    const body = {
      ...bodyFilter,
      page: 1,
      orgId: roleId,
      searchs: d.search
    }
    setPage(1)
    fnGetData(body)
  }

  const getFilesDocs = async ({ orgId, code, educationId, docTypeId }) => {
    const body = {
      orgId,
      code,
      educationId,
      docTypeId
    }
    fnGetEducationFile(body)
  }

  return (
    <div>
      <NavTitle>
        <TextNavTitle>Education</TextNavTitle>
      </NavTitle>
      <NavRoleOrg />
      <div className="p-3 bg-white rounded-top-3 shadow-sm">
        <Row>
          <Col md={4} className="my-auto small">
            <label
              className="my-auto fw-bold me-3"
              style={{
                fontSize: '14px'
              }}
            >
              Total: {totalRow?.toLocaleString()}
            </label>
            <label
              className="my-auto fw-bold ms-3"
              style={{
                fontSize: '14px'
              }}
            >
              Employee: {totalPerson?.toLocaleString()}
            </label>
          </Col>

          <Col md={8} className="">
            <BoxFilter className="justify-content-end">
              <Form className="from-search" onSubmit={handleSubmit(onSearch)}>
                <Controller
                  name={'search'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <InputSearchCustom
                      value={value}
                      onChange={(d) => {
                        onChange(d)

                        if (!d) {
                          onClearSearch()
                        }
                      }}
                      placeholder="Code/ Username/ Name/ ID Card/ PersonID"
                    />
                  )}
                />
              </Form>
              <Button
                className="px-4 text-primary"
                variant="light"
                onClick={() => {
                  setShowFilter(true)
                }}
              >
                <BsSliders2Vertical className="me-2" />
                More Filter
              </Button>
              <Button
                className="btn-reflesh"
                variant="light"
                onClick={() => {
                  const body = {
                    // ...bodyFilter,
                    startDate: `${fnDateEn(to_day).format('YYYY-MM-DD')}`,
                    endDate: `${fnDateEn(to_day).format('YYYY-MM-DD')}`,
                    page: 1,
                    orgId: roleId
                  }
                  setValue('search', '')
                  setPage(1)
                  fnGetData(body)
                }}
              >
                <BsArrowClockwise />
              </Button>
              <Button className="btn-excel" onClick={() => fnExportExcel()}>
                <Image src={excelImg} style={{ width: '15px' }} />
              </Button>
              {/* <ExportExcel fnExportExcel={fnExportExcel} /> */}
            </BoxFilter>
          </Col>
        </Row>
      </div>
      <CardCustom
        minHeight=""
        className="d-flex justify-content-between "
        style={{
          height: 'calc(100vh - 190px'
        }}
      >
        <Table hover responsive className="mb-3">
          <thead
            className="bg-hrms text-white "
            style={{ position: 'sticky', top: '0px' }}
          >
            <tr className=" font-title-table">
              <th
                className="fw-normal "
                style={{ whiteSpace: 'nowrap', minWidth: '40px' }}
              >
                #
              </th>

              <th
                className="fw-normal"
                style={{ whiteSpace: 'nowrap', minWidth: '80px' }}
              >
                Code
              </th>
              <th
                className="fw-normal"
                style={{ whiteSpace: 'nowrap', minWidth: '80px' }}
              >
                Level
              </th>
              <th
                className="fw-normal"
                style={{ whiteSpace: 'nowrap', minWidth: '200px' }}
              >
                Name
              </th>
              <th
                className="fw-normal"
                style={{ whiteSpace: 'nowrap', maxWidth: '80px' }}
              >
                Nickname
              </th>
              <th
                className="fw-normal text-center"
                style={{ whiteSpace: 'nowrap', maxWidth: '80px' }}
              >
                Group
              </th>
              <th
                className="fw-normal text-center"
                style={{ whiteSpace: 'nowrap', maxWidth: '100px' }}
              >
                Department
              </th>
              <th
                className="fw-normal"
                style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
              >
                Team
              </th>
              <th
                className="fw-normal"
                style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
              >
                Position
              </th>
              <th
                className="fw-normal"
                style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
              >
                อายุงาน (ปี)
              </th>
              <th
                className="fw-normal"
                style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
              >
                ประเภทพนักงาน
              </th>
              <th
                className="fw-normal"
                style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
              >
                Education Degree
              </th>
              <th
                className="fw-normal"
                style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
              >
                Institution Name
              </th>

              <th
                className="fw-normal"
                style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
              >
                Education Year
              </th>
              <th
                className="fw-normal"
                style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
              >
                Educational Qualification
              </th>
              <th
                className="fw-normal"
                style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
              >
                Faculty
              </th>
              <th
                className="fw-normal"
                style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
              >
                Major
              </th>
              <th
                className="fw-normal"
                style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
              >
                Grade
              </th>
              <th
                className="fw-normal text-center"
                style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
              >
                Transcript
              </th>
              <th
                className="fw-normal text-center"
                style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
              >
                Degree Graduated
              </th>
            </tr>
          </thead>
          <tbody className="text-break fw-light">
            {isLoading ? (
              <>
                <TableSkeletonBody colSpan={21} rowSpan={10} />
              </>
            ) : dataTable.length > 0 ? (
              dataTable.map((d, i) => (
                <tr className="mb-3 font-small-2 align-middle" key={i}>
                  <td>
                    {' '}
                    <span className="font-small-2">
                      {page * totalLimits - totalLimits + i + 1}
                    </span>
                  </td>

                  <td className="my-auto pe-0">
                    <p className="mb-1 font-small-2">{d?.code ?? '-'}</p>
                  </td>
                  <td className="my-auto pe-0">
                    <p className="mb-1 font-small-2">{d?.level_id ?? '-'}</p>
                  </td>
                  <td lg={2} className="my-auto ">
                    {!d.title_th && !d.name_th && !d.surname_th ? (
                      <p className="mb-0  font-small-2 ">-</p>
                    ) : (
                      <p className="mb-0  font-small-2 ">
                        <span className="me-1">
                          {d?.title_th ?? '-'}
                          {d?.name_th ?? '-'}
                        </span>{' '}
                        <span>{d?.surname_th ?? '-'}</span>
                      </p>
                    )}
                  </td>
                  <td className="my-auto">
                    <p className="mb-1  font-small-2">
                      {' '}
                      {d?.nickname_th ?? '-'}
                    </p>
                  </td>

                  <td className="my-auto ">
                    <p className="mb-1  font-small-2">{d.division}</p>
                  </td>
                  <td className="my-auto ">
                    <p className="mb-1  font-small-2">{d.department}</p>
                  </td>
                  <td className="my-auto ">
                    <p className="mb-1  font-small-2">{d.team_en}</p>
                  </td>
                  <td className="my-auto ">
                    <p className="mb-1  font-small-2">{d.position_en}</p>
                  </td>
                  <td className="my-auto ">
                    <p className="mb-1  font-small-2">{d.duration_text}</p>
                  </td>
                  <td className="my-auto ">
                    <p className="mb-1  font-small-2">{d.type}</p>
                  </td>
                  <td className="my-auto ">
                    <p className="mb-1  font-small-2">{d.education_degree}</p>
                  </td>
                  <td className="my-auto ">
                    <p className="mb-1  font-small-2">{d.institution_name}</p>
                  </td>

                  <td className="my-auto ">
                    <p className="mb-1  font-small-2">
                      {d.admission_year}-{d.graduation_year}
                    </p>
                  </td>
                  <td className="my-auto ">
                    <p className="mb-1  font-small-2">
                      {d.education_qualification}
                    </p>
                  </td>
                  <td className="my-auto ">
                    <p className="mb-1  font-small-2">{d.faculty}</p>
                  </td>
                  <td className="my-auto ">
                    <p className="mb-1  font-small-2">{d.major}</p>
                  </td>
                  <td className="my-auto ">
                    <p className="mb-1  font-small-2">{d.grade}</p>
                  </td>
                  <td className="my-auto">
                    <p className="mb-1  font-small-2 text-center">
                      {d.tran_file_name ? (
                        <BsFillFileEarmarkPdfFill
                          onClick={() => {
                            getFilesDocs({
                              orgId: d.org_id,
                              code: d.code,
                              educationId: d.id,
                              docTypeId: d.tran_file_type
                            })
                          }}
                          className="opacity-25 mt-2"
                          style={{
                            fontSize: '1.5rem',
                            cursor: 'pointer'
                          }}
                        />
                      ) : (
                        '-'
                      )}
                    </p>
                  </td>
                  <td className="my-auto">
                    <p className="mb-1  font-small-2 text-center">
                      {d.cer_file_name ? (
                        <BsFillFileEarmarkPdfFill
                          onClick={() => {
                            getFilesDocs({
                              orgId: d.org_id,
                              code: d.code,
                              educationId: d.id,
                              docTypeId: d.cer_file_type
                            })
                          }}
                          className="opacity-25 mt-2"
                          style={{
                            fontSize: '1.5rem',
                            cursor: 'pointer'
                          }}
                        />
                      ) : (
                        '-'
                      )}
                    </p>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="table-body">
                <td colSpan={21} className="text-center">
                  -No Data-
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        <div className="p-3">
          <PaginationControl
            page={page}
            total={totalRow}
            limit={totalLimits}
            changePage={(p) => {
              const body = {
                ...bodyFilter,
                page: p
              }
              fnGetData(body)
              setPage(p)
            }}
            ellipsis={1}
          />
        </div>
      </CardCustom>

      {showFilter && (
        <ModalFilter
          open={showFilter}
          onCancel={() => {
            setShowFilter(false)
          }}
          bodyFilter={bodyFilter}
          fnGetData={(body) => {
            fnGetData(body)
          }}
          roleId={roleId}
          isLoading={isLoading}
        />
      )}
    </div>
  )
}

const BoxFilter = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .from-search {
    flex: 0 0 350px;
  }
  .btn-reflesh {
    flex: 0 0 30px;
  }
  .btn-excel {
    flex: 0 0 30px;
  }
  .btn-status {
    flex: 0 0 150px;
  }
`
